type QueryLoadingProps = {
  variant?: "thread" | "screen";
};

export function QueryLoading({ variant = "thread" }: QueryLoadingProps) {
  return (
    <section
      className={`sa-query-loading sa-query-loading--${variant}`}
      role="status"
      aria-live="polite"
      aria-label="Loading response"
    >
      <div className="sa-query-loading__text">
        <span>loading</span>
        <span className="sa-query-loading__dots" aria-hidden="true">
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      </div>
    </section>
  );
}
